module.exports = __webpack_public_path__ + "img/brand-02.0f998484.png";